const translations = {
  "en": {
    "coming soon": "coming soon"
  },
  "zh-tw": {
    "coming soon": "即將推出"
  }
};

export default translations;
